var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aside-wrap"},[_c('div',{staticClass:"user-aside"},[_c('div',{staticClass:"userinfo"},[_c('img',{attrs:{"src":_vm.item.icon?_vm.item.icon:require('@/assets/default-avatar.png')}}),_c('span',{staticClass:"username"},[_vm._v("#"+_vm._s(_vm.item.categoryName)+"#")]),_c('div',[_vm._v(_vm._s(_vm.item.content))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }